var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-home"},[_c('SearchBar',{attrs:{"placeholder":"请输入姓名和企业名称"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_c('VoteList',{attrs:{"search":_vm.search,"listType":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }